const centsToDollars = (cents: number): string =>
  new Intl.NumberFormat('en-EN', {
    maximumFractionDigits: 2,
    minimumFractionDigits: 2,
    style: 'decimal',
    useGrouping: false,
  }).format(cents / 100.0)

export default centsToDollars
